"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const sidebarContainer = status => ({
    width: status === 'expand' ? constants_1.sidebarStyle.menuWidth : constants_1.sidebarStyle.menuWidthColapse,
    height: constants_1.sidebarStyle.menuHeight,
    marginTop: constants_1.navbarStyle.height,
    paddingBottom: 100,
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: constants_1.fixedZIndex.sidebar,
    color: constants_1.color.white,
    backgroundColor: constants_1.color.red,
    overflowY: 'scroll'
});
const menu = {
    height: `calc(100vh - ${constants_1.navbarStyle.height} - 70px)`,
    overflowY: 'scroll'
};
const menuItem = (selected) => ({
    height: '48px',
    fontSize: '10px',
    padding: '12px 24px',
    cursor: 'pointer',
    backgroundColor: selected ? constants_1.color.sidebarItemSelected : undefined,
    display: 'flex',
    alignItems: 'center'
});
const keyboardIcon = {
    width: 8,
    height: 6,
    marginLeft: 'auto'
};
const menuIcon = {
    width: '24px',
    height: '24px'
};
const subMenuIcon = {
    width: '20px',
    height: '20px',
};
const menuTitle = (selected) => ({
    fontSize: '14px',
    color: selected ? constants_1.color.sidebarTitleDark : constants_1.color.white,
    marginLeft: 10
});
const subMenuTitle = {
    fontSize: '12px',
    color: constants_1.color.white,
    marginLeft: 10
};
const subMenuGroupContainer = {
    marginTop: '25px',
    paddingBottom: '25px'
};
const subMenuItem = (selected, mode) => ({
    height: '48px',
    fontSize: '10px',
    padding: '12px 24px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: selected
        ? mode === 'light' ? constants_1.color.sidebarItemActiveLight : constants_1.color.sidebarItemActiveDark
        : mode === 'light' ? constants_1.color.sidebarItemInactiveLight : constants_1.color.sidebarItemInactiveDark
});
const subMenuText = {
    fontSize: '10px',
};
const sidebarTitle = theme => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 28px',
    fontWeight: 'bold',
    height: 50,
    backgroundColor: theme === 'light' ? '#494949' : 'unset'
});
const sidebarLogo = {
    height: 40,
    width: 40,
    marginRight: 5
};
const switchMode = status => ({
    marginLeft: status === 'expand' ? 24 : 12
});
const switchIcon = {
    borderRadius: '50%',
    backgroundColor: '#BA352C',
    display: 'grid',
    placeItems: 'center'
};
const toggleIcon = {
    height: 21,
    width: 24
};
const switchImageIcon = {
    height: 20,
    width: 20
};
exports.default = {
    sidebarContainer,
    menuItem,
    menuIcon,
    subMenuIcon,
    menuTitle,
    subMenuGroupContainer,
    subMenuItem,
    subMenuText,
    sidebarTitle,
    keyboardIcon,
    subMenuTitle,
    sidebarLogo,
    switchMode,
    menu,
    switchIcon,
    toggleIcon,
    switchImageIcon
};
